import { render, staticRenderFns } from "./IncluirDependente.vue?vue&type=template&id=73e730d7&"
import script from "./IncluirDependente.vue?vue&type=script&lang=js&"
export * from "./IncluirDependente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports